<div>
  <b>Old Manager</b>
  <br/>
  <dw-autocomplete-readonly #Title [useServerSearch]="true" [lookupId]="lookupId" [(ngModel)]="lookupValue"></dw-autocomplete-readonly>
</div>
